import { sessionStorageProxy } from "@sportal/api";
import { REPORTS_CACHE_NAME } from "@sportal/api/reports";

export const SessionStorageKeys = {
  LogoutReason: "logoutReason",
  Reports: REPORTS_CACHE_NAME,
};

export { sessionStorageProxy };
